<div *ngIf="variablesService.social && !vwo.social_share_btns_AB()" (click)="shareClickListner($event)" [ngClass]="{'active': showBtns}" class="floating-share">
  <div *ngIf="telegram" class="fab telegram" [ngClass]="{'no': noClass, 'active': showBtns}">
    <app-telegram-share [isFundraiserEnded]="isFundraiserEnded"></app-telegram-share>
  </div>
  <div class="fab whatsapp" [ngClass]="{'no': noClass, 'active': showBtns}">
    <app-whatsapp-share buttonType="round" [fundraiser]="fundraiser" [basicInfo]="basicInfo"
                        [isFundraiserEnded]="isFundraiserEnded" position="PosOS1" [dream11]="dream11">
    </app-whatsapp-share>
  </div>
  <div class="fab facebook" [ngClass]="{'no': noClass, 'active': showBtns}">
    <app-fb-share buttonType="round" [fundraiser]="fundraiser" position="PosOS1">
    </app-fb-share>
  </div>
</div>

<div *ngIf="variablesService.social && vwo.social_share_btns_AB()" (click)="shareClickListner($event)" 
  [ngClass]="{'active': showBtns, 
              'v1': vwo.quickDonate_fallback_p1_AB()==='v1' && variablesService.userData?.getValue()?.lastorder?.iso_currency === currency, 
              'v2': vwo.quickDonate_fr_AB() && variablesService.userData?.getValue()?.lastorder?.iso_currency === currency && this.variablesService?.pageName === 'campaign' && currency === 'INR', 
              'v3': vwo.quickDonate_fr_AB() && variablesService.userData?.getValue()?.lastorder?.iso_currency === currency && this.variablesService?.pageName === 'campaign' && currency !== 'INR',
              'v4': vwo.update_nudge_AB() && this.variablesService?.pageName === 'stories' && variablesService.userData && variablesService.prevOrderDetails,
              'v5': vwo.story_variation_2() && isMobile && !userData?.aggdonationall?.funds}" 
              class="floating-share">
  <div class="fab" [ngClass]="{'no': noClass, 'active': showBtns, 'v5': vwo.story_variation_2() && isMobile && !userData?.aggdonationall?.funds}" *ngFor="let btn of shareButtons">
    <button [ngStyle]="{'background-color': btn.color}" (click)="share(btn)" mat-icon-button>
      <mat-icon [ngClass]="btn.icon"></mat-icon>
    </button>
  </div>
</div>
